<template>
  <i-section :scrollable="false">
    <div class="px-4 search">
      <wildcard-search />
    </div>
    <v-divider />
    <div class="action-bar px-4 mb-2 mt-2">
      <type-select v-if="allowAllSlidesSearch" />
      <v-spacer />
      <v-btn class="mx-2" small icon @click="resetFilter">
        <v-icon>{{ icons.undo }}</v-icon>
      </v-btn>
    </div>

    <workflow-filter />
    <i-section class="border-top">
      <collection-filter :items="chapters" title="Chapter" collection-type="chapter" />
      <collection-filter :items="flows" title="Flow" collection-type="flow" />
      <collection-filter :items="cycles" title="Update Cycle" collection-type="update" />
      <archived-filter />
      <localization-filter v-if="!isMaster"></localization-filter>
      <boolean-filter label="Show localized slides" filter-key="localized" v-if="isMaster" />
    </i-section>
  </i-section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { PUBLIC_STATI, SLIDES_RESET_FILTER, SLIDES_SET_FILTER, SORT_PARAMETER } from '@/config/constants';
import * as _ from 'lodash';
import icons from '../../mixins/icons';
import CoreButtonVue from '../core/buttons/CoreButton.vue';
import WorkflowFilter from '../filter/WorkflowFilter.vue';
import ArchivedFilter from '../filter/ArchivedFilter.vue';
import CollectionFilter from '../filter/CollectionFilter.vue';
import WildcardSearch from '../filter/WildcardSearch.vue';
import { EventBus } from '../../event-bus';
import TypeSelect from '../filter/TypeSelect.vue';
import BooleanFilter from '../filter/BooleanFilter';
import LocalizationFilter from '../filter/LocalizationFilter';

export default {
  name: 'FilterComponent',
  components: {
    LocalizationFilter,
    BooleanFilter,
    coreButton: CoreButtonVue,
    workflowFilter: WorkflowFilter,
    archivedFilter: ArchivedFilter,
    collectionFilter: CollectionFilter,
    wildcardSearch: WildcardSearch,
    typeSelect: TypeSelect
  },
  mixins: [icons],
  props: {
    allowAllSlidesSearch: {
      type: Boolean,
      default: false
    },
    numberItems: {
      type: Number,
      default: 0
    },
    canCopyUrl: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      filter: true,
      sortParameter: SORT_PARAMETER,
      canReset: Object.values(this.$router.currentRoute.query).length > 0,
      active: {
        status: true,
        cycle: true,
        chapter: true,
        flow: true
      },
      selected: {
        status: this.check(this.$route.query.status),
        type: this.$route.query.type,
        flow: this.check(this.$route.query.flow),
        chapter: this.check(this.$route.query.chapter),
        update: this.check(this.$route.query.cycle),
        sort: this.$route.query.sort,
        wildcard: this.$route.query.wildcard,
        localized: this.$route.query.localized,
        localizing: this.$route.query.localizing,
        comparing: this.$route.query.comparing
      }
    };
  },
  // watch: {
  //   selected: {
  //     handler: async function(selected) {
  //       const filter = this.filterQuery(selected);
  //       this.setSlideFilter(filter);
  //       this.$router.push({ query: { ...this.$route.query, ...filter } });
  //       this.canReset = true;
  //     },
  //     deep: true
  //   },
  //   slideFilter: {
  //     handler: function() {
  //       this.getFilteredSlides();
  //       this.selected = { ...this.slideFilter };
  //     },
  //     deep: true
  //   }
  // },
  mounted() {
    EventBus.$on('reset-filter', () => {
      this.typeSelect = 'main';
    });
  },
  methods: {
    ...mapActions({
      getFilteredSlides: 'slides/getFiltered',
      resetSlideFilter: 'slides/resetFilter',
      setSlideFilter: 'slides/setFilter',
      getFilteredFlows: 'flows/getFiltered',
      getFilteredChapters: 'chapters/getFiltered'
    }),
    getSavedFilterState() {
      localStorage.getItem('filter');
    },
    saveFilterState() {
      localStorage.setItem('filter', JSON.stringify(this.filter));
    },
    debounceInput: _.debounce(function(e) {
      let v = e;
      if (e === '') {
        e = null;
      }
      this.$store.commit('filter/setFilterItem', { key: 'wildcard', val: e });
    }, 500),
    check(s) {
      if (s) {
        if (s.constructor === String) {
          return [s];
        } else {
          return s;
        }
      }
      return s;
    },
    resetFilter() {
      EventBus.$emit('reset-filter', true);
      this.$store.commit('filter/resetFilter');
    },
    filterQuery(selected) {
      let filter = {};
      for (let key in selected) {
        if (selected.hasOwnProperty(key)) {
          const value = selected[key];
          if (value) {
            filter[key] = value;
          }
        }
      }
      return filter;
    }
  },
  computed: {
    typeSelect: {
      get() {
        return this.selected.type === '';
      },
      set(e) {
        this.selected.type = e ? null : 'main';
        this.$store.commit('filter/setFilterItem', {
          key: 'type',
          val: this.selected.type
        });
      }
    },
    status: () => {
      return PUBLIC_STATI.map(status => {
        return { value: status.internal, public: status.public };
      });
    },
    ...mapState('flows', {
      flows: state => state.items
    }),
    ...mapState('core', {
      isMaster: state => state.settings.libs.current.isMaster
    }),
    ...mapState('slides', {
      slideFilter: state => state.filter
    }),
    ...mapState('chapters', {
      chapters: state => state.items
    }),
    ...mapState('cycles', {
      cycles: state => state.cycles
    })
  }
};
</script>

<style scoped>
.search {
  padding-top: 16px;
  padding-bottom: 16px;
}
.drawer-permanent {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  width: 100% !important;
}
.wrap {
  min-height: 200px;
}
.wrapper {
  height: 100%;
  position: relative;
}
.inner-wrapper {
  position: absolute;
  flex: 1;
  overflow: scroll;
  height: 100%;
}
.button {
  background-color: var(--blue) !important;
  width: 100%;
  margin: 0px;
}

.v-input__icon--append-outer i {
  color: var(--dark) !important;
}

.white {
  background-color: white !important;
}

.headline {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
}

.headline:not(:first-child) {
  margin-top: 10px;
}

.input {
  background-color: var(--light-form-bg) !important;
}

.subline {
  font-size: 14px;
  font-weight: bold;
  display: inline-flex;

  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px dotted var(--new-blue);
}

.filter-box:first-child {
  margin-top: 25px;
}

.font-color {
  color: var(--new-blue) !important;
}
.filter-box {
  margin-top: -1px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.12); */
}

.action-bar {
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}
.header {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}
.border-top {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
